<template>
  <div>
    <md-button class="md-fab md-fab-bottom-right" v-on:click="showSendNew = true">
      <md-icon>add</md-icon>
      <md-tooltip md-direction="top">New Conversation</md-tooltip>
    </md-button>
    <md-dialog :md-active.sync="showSendNew">
      <md-dialog-title>New Message</md-dialog-title>
      <form class="md-layout" v-on:submit.prevent="sendMessage">
        <md-card class="sendMessage">
          <!-- <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-15">
              <md-field md-inline>
                <label>Area Code</label>
                <md-input v-model="this.areacode" maxlength=3 v-on:keyup="nextWhenFull(3)"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-15">
              <md-field md-inline>
                <label>Prefix</label>
                <md-input v-model="this.prefix" maxlength=3 v-on:input="nextWhenFull(3, 'numberfield')" ref="prefixfield"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20"> -->
              <md-field md-inline>
                <label>Number</label>
                <md-input v-model="number" maxlength=10 ref="numberfield" onfocus="this.value = this.value"></md-input>
              </md-field>
            <!-- </div>
          </div> -->
          <md-field>
            <label>Message</label>
            <md-textarea v-model="message" maxlength=500 class="message" v-on:keyup.enter="sendMessage"></md-textarea>
          </md-field>
        </md-card>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <md-dialog-actions>
          <md-button class="md-secondary" @click="showSendNew = false">Cancel</md-button>
          <md-button class="md-primary" @click="sendMessage">Send</md-button>
        </md-dialog-actions>
      </form>
    </md-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'sendNew',
  data () {
    return {
      showSendNew: false,
      sending: false,
      sendEndpoint: 'https://api.cvstech.com/twilio/sendmessage',
      areacode: '217',
      prefix: '',
      number: '217',
      message: ''
    }
  },
  computed: {
    ...mapState([
      'userfirstname',
      'userlastname',
      'useremail',
      'usercolor',
      'userlevel',
      'userTwilioAccountSID',
      'teamTwilioAccountSID',
      'teamTwilioAuthToken',
      'teamTwilioSMSNumber',
      'teamname',
      'teamlastupdate',
      'teamlastcommfrom'
    ]),
    ...mapFields([
      'selectedcontactSMS',
      'forceConversationUpdate'
    ])
  },
  watch: {
    showSendNew: function (newshowSendNew, oldshowSendNew) {
      console.log('oldshowSendNew: ' + oldshowSendNew)
      console.log('newshowSendNew: ' + newshowSendNew)
      if (newshowSendNew) {
        console.log(this.$refs)
        // this.$refs.prefixfield.$el.focus()
        setTimeout(() => { this.$refs.numberfield.$el.focus() }, 500)
      }
    }
  },
  created () {
    this.forceConversationUpdate = false
  },
  methods: {
    sendMessage () {
      axios.post(this.sendEndpoint,
        {
          sid: this.teamTwilioAccountSID,
          token: this.teamTwilioAuthToken,
          to: '+1' + this.number,
          body: this.message,
          from: this.teamTwilioSMSNumber
        })
        .catch(error => {
          console.log('-----error-------')
          console.log(error)
        })
      this.message = ''
      this.showSendNew = false
      this.forceConversationUpdate = true
      this.selectedcontactSMS = '+1' + this.number
      // setTimeout(() => { this.updateScroll() }, 500)
    },
    nextWhenFull (count, fieldreference) {
      console.log('event')
      console.log(this.target)
      console.log('count')
      console.log(count)
      console.log('field')
      console.log(fieldreference)
      // var elem = document.getElementById(fieldreference)
      // if (elem) {
      //   console.log(elem.value)
      //   // if (elem.value.length === count) {
      //   //   console.log('next!')
      //   // }
      // }
    }
  }
}
</script>

<style lang="css" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-card {
  width: 100%;
  padding: 10px;
}
.sendMessage {
  min-width: 350px;
  min-height: 250px;
}
.left {
  text-align: left;
}
.message {
  font-size: 12pt;
}
</style>



// WEBPACK FOOTER //
// src/components/NewMessage.vue